import { ConfigService } from "@archipad-js/core/config";
import { Public } from "@archipad-js/core/utils";

import { BaseEntity } from "./base-entity";
import { DynamicEntities } from "./dynamic-entities";
import { EntityContext } from "./entity-context";
import { buildSchema } from "./schema-builder";
import { EntityTypes, Validator } from "./types";
import { InternationalizationService, LocalizationService } from "@archipad-js/core/translate";

export type ISchemaManager = Public<SchemaManager>;

export class SchemaManager {
    constructor(
        private readonly localizationService: LocalizationService,
        private readonly internalizationService: InternationalizationService,
        private readonly entityClasses: ReadonlyMap<string, typeof BaseEntity>,
        private readonly validators: ReadonlyArray<Validator>,
        private readonly configService: ConfigService,
    ) {}

    /**
     * Returns an {@link EntityContext} loaded with the schema (`model.json`)
     * available in the configuration.
     *
     * Also loads custom entity classes, extensions and validators.
     */
    public async entityContextFromConfiguration(): Promise<EntityContext> {
        const metadata = await this.getModelSchema();

        const entityTypes: EntityTypes = buildSchema(metadata);

        const dynamicEntities = new DynamicEntities(entityTypes, this.entityClasses);

        const entityContext = new EntityContext(
            this.localizationService,
            this.internalizationService,
            entityTypes,
            dynamicEntities,
            this.validators,
            metadata,
        );
        return entityContext;
    }

    private async getModelSchema(): Promise<unknown> {
        const modelSchema = await this.configService.get("model");
        return modelSchema;
    }
}
